module.exports = __webpack_public_path__ + "static/media/imag2.61d87361.jpg";